import { BikeElevationSection as section } from './bike-elevation-graph-util'
import BikeElevation from './BikeElevation'

export type BikeElevationSection = section
export default BikeElevation
